module.exports = __webpack_public_path__ + "img/im-logo.2beb0e8d.png";